
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { Lead, Operation, Tag } from '@/types';

@Component
export default class LeadTags extends Vue {
  @Prop(Object) readonly lead: undefined | Lead;
  @Prop(Object) readonly operation: undefined | Operation;
  @Prop({ type: Boolean, default: false }) readonly small!: boolean;

  get tags(): null | Tag[] {
    return this.$store.getters.tags;
  }

  get hasTags(): boolean {
    if (this.lead !== undefined) {
      return typeof this.lead.flatTags === 'string' && this.lead.flatTags.length > 2;
    }

    if (this.operation !== undefined) {
      return typeof this.operation.tags === 'string' && this.operation.tags.length > 2;
    }

    return false;
  }

  get leadTags(): number[] {
    if (this.lead !== undefined) {
      return this.hasTags && 'flatTags' in this.lead && this.lead.flatTags
        ? this.lead.flatTags.substring(1, this.lead.flatTags.length - 1).split(':')
          .map((s: string) => Number(s))
        : [];
    }

    if (this.operation !== undefined) {
      return this.hasTags && 'tags' in this.operation && this.operation.tags
        ? this.operation.tags.substring(1, this.operation.tags.length - 1).split(':')
          .map((s: string) => Number(s))
        : [];
    }

    return [];
  }

  leadTag(tagId: number) {
    if (!this.tags) return null;

    return this.tags.find((tag) => tag.id === tagId);
  }

  tagColor(tagId: number): string {
    const tag = this.leadTag(tagId);

    const baseColor = tag?.color ? tag.color : 'light-blue';

    // Se il tag è nascosto o disattivato, schiarisce il colore
    if (tag?.hidden || tag?.isActive === false) return `${baseColor} lighten-3`;

    return baseColor;
  }
}
